import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import AIGeneratorButton from '../../../aiMessageGenerator/aiGeneratorButton/AIGeneratorButton';
import AIWhatsappGenerator from '../../../aiWhatsappGenerator/AIWhatsappGenerator';
import useShow, {TShow} from '../../../../hooks/useShow';
import {TState} from '../../../../redux/store.type';
import {logGoogleEvent} from '../../../../utils/analytics';
import {TemplateStructure, TextTemplateItem} from '../../../whatsAppTemplateEditor/types/templateStructure';

interface UseSendingPopupAiGeneratorArgs {
    mailingSource?: string;
    variablesType: string;
    saveText: (payload: TemplateStructure | TextTemplateItem[] | string) => void;
}

export function useSendingPopupAiGenerator({mailingSource, variablesType, saveText}: UseSendingPopupAiGeneratorArgs) {
    const eid = useSelector((s: TState) => s.event?.eid);
    const aiGeneratorShow = useShow();
    const messageType = mailingSource ?? variablesType;

    const handleUpdateMessage = useCallback((structure: TemplateStructure) => {
        saveText(structure);
    }, [saveText]);

    const openAiGenerator = useCallback(() => {
        if(eid) {
            logGoogleEvent('ai_message_generator_open', eid, {
                popup_name: 'aiMessageGenerator',
                message_type: messageType,
                feature: 'sending_popup',
            });
        }
        aiGeneratorShow.open();
    }, [eid, messageType, aiGeneratorShow]);

    return {aiGeneratorShow, messageType, openAiGenerator, handleUpdateMessage};
}

export function SendingPopupAiGeneratorButton({onClick}: {onClick: () => void}) {
    const {t} = useTranslation('whatsapp');

    return (
        <AIGeneratorButton
            label={t('aiGenerator.triggerLabel')}
            onClick={onClick}
            data-testid="sending-popup-ai-generator-trigger"
        />
    );
}

export function SendingPopupAiGeneratorPanel({
    show,
    messageType,
    onUpdateMessage,
}: {
    show: TShow;
    messageType: string;
    onUpdateMessage: (structure: TemplateStructure) => void;
}) {
    return (
        <AIWhatsappGenerator
            show={show}
            messageType={messageType}
            updateMessage={onUpdateMessage}
            persistOnApprove={false}
            container="innerPop"
        />
    );
}
